import React from 'react'

function Social() {
  return (
    <div className="home__social">
        <a href="https://instagram.com/shubham_vadhariya?igshid=ZDdkNTZiNTM=" className="home__sociial-icon" target="_blank">
        <i className="uil uil-instagram"></i>
        </a>


        <a href="https://www.linkedin.com/in/shubham-vadhariya-808380229" className="home__sociial-icon" target="_blank"><i className="uil uil-linkedin"></i>

        </a>

        <a href="https://github.com/shuham5954" className="home__sociial-icon" target="_blank"><i className="uil uil-github"></i>

        </a>

        <a href="https://youtube.com/@justaron8915" className="home__sociial-icon" target="_blank"> <i className="uil uil-youtube"></i>

        </a>


       
    </div>
  )
}

export default Social